


import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import Footer from "../../../components/ru/FooterRu";
import { Link } from "react-router-dom";

function StudyInRussia() {

   // Estado para controlar el acordeón
   const [activeIndex, setActiveIndex] = useState(null);

   const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
   };


   return (
      <main>
         {/* ========================== SEO ========================== */}
         <Helmet>
            <title>Почему Учиться в России? 10 Ключевых Причин и Полное Руководство 2025 | PLAN RUSIA </title>
            <meta name="description" content="Стоит ли учиться в России? Откройте для себя 10 академических, экономических и культурных преимуществ, подтвержденных официальными данными. Обновленное руководство с требованиями на 2025 год" />
            <meta name="keywords" content="учеба в России, российские университеты, стипендии в России, изучение медицины в России, стоимость жизни в России" />
            <meta property="og:title" content="Почему Учиться в России? Ключевые Преимущества для Иностранных Студентов" />
            <meta property="og:description" content="Всё, что нужно знать для учебы в России: от поступления до студенческой жизни. Откройте для себя уникальные возможности!" />
            <meta property="og:image" content="https://planrusia.com/assets/img/education/universidad-rusas-educacion.webp" />
            <link rel="canonical" href="https://planrusia.com/why-study-in-russia" />

            <meta property="og:url" content="https://planrusia.com/why-study-in-russia" />
            <meta property="og:type" content="article" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="10 Причин Учиться в России" />
            <meta name="twitter:image" content="https://planrusia.com/why-study-in-russia" />
         </Helmet>

         {/* ==================== Contenido Principal ==================== */}
         <section className="blog_area single-post-area section-padding">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8 posts-list">
                     <div className="single-post">
                        <div className="feature-img">
                           <img
                              className="img-fluid"
                              src="/assets/img/education/universidad-rusas-educacion.webp"
                              alt="Иностранные студенты в российском университетском кампусе"
                              loading="lazy"
                           />
                        </div>

                        <div className="blog_details">
                           <h1 itemProp="headline">
                              Почему Учиться в России? 10 Преимуществ, Которые Стоит Знать в 2025
                           </h1>

                           <div className="meta-info" itemScope itemType="http://schema.org/Article">
                              <span itemProp="datePublished"> 1 Июня 2025</span>
                              <span itemProp="author"> От - Российский Образовательный Совет</span>
                           </div>

                           <ul className="blog-info-link mt-3 mb-4">
                              <li>
                                 <a href="#">
                                    <i className="fa fa-user" /> Образование, Руководства
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fa fa-comments" /> 12 Комментариев
                                 </a>
                              </li>
                           </ul>

                           <article itemProp="articleBody">


                              <p className="excert">
                                 С более чем 300 000 иностранных студентов (согласно данным <a href="https://uis.unesco.org/" target="_blank" rel="noopener noreferrer">ЮНЕСКО</a>), Россия позиционирует себя как образовательная держава. Но что делает её такой привлекательной? Мы анализируем академические, экономические и культурные факторы.
                              </p>


                              {/* ============ ÍTEM 1 ============ */}
                              <h2>1. Образование Мирового Класса. Академическое Превосходство по Доступной Цене</h2>

                              <p>
                                 <strong>Рейтинг QS 2024</strong> включает 17 российских университетов среди 500 лучших в мире. Среди них выделяются:
                              </p>
                              <ul>
                                 <li>• Московский Государственный Университет (Ломоносова) - №74 в мире по физике</li>
                                 <li>• МФТИ - Топ-50 в области ядерной инженерии</li>
                                 <li>• МГИМО - №1 по международным отношениям в Восточной Европе</li>
                              </ul>
                              <p>
                                 Стоимость обучения от $2,500 в год против $50,000 в Лиге Плюща (<a href="https://www.minobrnauki.gov.ru/" target="_blank" rel="noopener noreferrer">Министерство образования РФ</a>).
                              </p>



                              <p>Россия занимает <strong>6-е место в мире</strong> по научным публикациям (Scimago 2023). Среди лидеров:</p>
                              <div className="row mb-4">
                                 <div className="col-md-6">
                                    <div className="card uni-card h-100">
                                       <div className="card-body">
                                          <h5>Московский Государственный Университет (МГУ)</h5>
                                          <ul>
                                             <li>№74 в мировом рейтинге QS 2024</li>
                                             <li>11 Нобелевских лауреатов</li>
                                             <li>Стоимость обучения: $3,000-$6,000/год</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="card uni-card h-100">
                                       <div className="card-body">
                                          <h5>Университет ИТМО</h5>
                                          <ul>
                                             <li>№1 в области компьютерных наук в России</li>
                                             <li>7-кратный чемпион ACM ICPC</li>
                                             <li>Доступны полные стипендии</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                              </div>


                              {/* ============ ÍTEM 2 ============ */}
                              <h2>2. Государственные Стипендии (Полное Покрытие) для Иностранцев</h2>

                              <ol>
                                 <li>15,000 ежегодных государственных стипендий для лучших иностранных студентов</li>
                                 <li>Полное покрытие: обучение + проживание + медицинская страховка</li>
                                 <li>Онлайн-заявка с ноября по декабрь каждого года</li>
                              </ol>

                              <table className="table table-bordered">
                                 <thead className="thead-dark">
                                    <tr>
                                       <th>Тип стипендии</th>
                                       <th>Преимущества</th>
                                       <th>Требования</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr>
                                       <td>Государственная стипендия</td>
                                       <td>100% обучение + проживание</td>
                                       <td>Минимальный средний балл 80/100</td>
                                    </tr>
                                    <tr>
                                       <td>Open Doors</td>
                                       <td>Обучение + $500/месяц</td>
                                       <td>Тест на талант и знания</td>
                                    </tr>
                                 </tbody>
                              </table>
                              <p><small>Источник: <a href="https://education-in-russia.com" target="_blank" rel="noopener">Education in Russia</a></small></p>




                              {/* ============ ÍTEM 3 ============ */}


                              <h2>3. Программы на Английском Языке (Без Знания Русского)</h2>

                              <p>
                                 58 университетов предлагают более 700 программ на английском языке в таких областях, как:
                              </p>
                              <ul>
                                 <li>• Медицина (MBBS признан ВОЗ)</li>
                                 <li>• Аэрокосмическая инженерия</li>
                                 <li>• Искусственный интеллект</li>
                                 <li>• Ядерная инженерия</li>
                              </ul>

                              <div className="accordion mb-4" id="programsAccordion">
                                 {[
                                    {
                                       title: "Медицина (MBBS)",
                                       content: (
                                          <ul>
                                             <li><strong>Продолжительность:</strong> 6 лет</li>
                                             <li><strong>Признание:</strong> ВОЗ, ECFMG, GMC</li>
                                             <li><strong>Лучшие университеты:</strong>
                                                <ul>
                                                   <li>Сеченовский университет (Москва)</li>
                                                   <li>Российский университет дружбы народов (РУДН)</li>
                                                   <li>Казанский федеральный университет</li>
                                                </ul>
                                             </li>
                                             <li><strong>Требования:</strong>
                                                <ul>
                                                   <li>Минимальные оценки: 80% по биологии/химии</li>
                                                   <li>Экзамен NEET для индийских студентов</li>
                                                </ul>
                                             </li>
                                          </ul>
                                       )
                                    },
                                    {
                                       title: "Аэрокосмическая инженерия",
                                       content: (
                                          <ul>
                                             <li><strong>Продолжительность:</strong> 4 года (бакалавриат)</li>
                                             <li><strong>Выдающиеся учреждения:</strong>
                                                <ul>
                                                   <li>Московский авиационный институт (МАИ)</li>
                                                   <li>Московский государственный технический университет им. Баумана</li>
                                                </ul>
                                             </li>
                                             <li><strong>Направления:</strong>
                                                <ul>
                                                   <li>Проектирование ракет</li>
                                                   <li>Космическая тяга</li>
                                                   <li>Композитные материалы</li>
                                                </ul>
                                             </li>
                                             <li><strong>Практика:</strong> Роскосмос, Объединенная авиастроительная корпорация</li>
                                             <li><strong>Средняя зарплата:</strong> $3,500/месяц</li>
                                          </ul>
                                       )
                                    },
                                    {
                                       title: "Искусственный интеллект",
                                       content: (
                                          <ul>
                                             <li><strong>Продолжительность:</strong> 2 года (магистратура)</li>
                                             <li><strong>Выдающиеся учреждения:</strong>
                                                <ul>

                                                   <li>Московский государственный технический университет им. Баумана</li>
                                                </ul>
                                                <li><strong>Охватываемые области:</strong>
                                                   <ul>
                                                      <li>Машинное обучение</li>
                                                      <li>Компьютерное зрение</li>
                                                      <li>Обработка естественного языка</li>
                                                   </ul>
                                                </li>
                                                <li><strong>Промышленные сотрудничества:</strong>
                                                   <ul>
                                                      <li>Школа анализа данных Яндекс</li>
                                                      <li>Сколковский институт науки и технологий</li>
                                                   </ul>
                                                </li>
                                             </li>
                                          </ul>
                                       )
                                    }

                                 ].map((item, index) => (
                                    <div className="accordion-item" key={index}>
                                       <button
                                          className={`accordion-button ${activeIndex === index ? 'active' : ''}`}
                                          onClick={() => toggleAccordion(index)}
                                       >
                                          {item.title}
                                          <span className="accordion-icon">
                                             {activeIndex === index ? '−' : '+'}
                                          </span>
                                       </button>
                                       <div
                                          className="accordion-body"
                                          style={{
                                             display: activeIndex === index ? 'block' : 'none'
                                          }}
                                       >
                                          {item.content}
                                       </div>
                                    </div>
                                 ))}
                              </div>

                              {/* ============ ÍTEM 4 ============ */}
                              <h2>4. Доступная Стоимость Жизни</h2>

                              <p>
                                 Конкурентоспособная стоимость жизни. От $400/месяц в таких городах, как Казань, против $1,200+ в Западной Европе (данные Numbeo 2024).
                              </p>

                              <div className="row">
                                 <div className="col-md-6">
                                    <h5>Ежемесячное сравнение (USD)</h5>
                                    <ul className="list-group">
                                       <li className="list-group-item d-flex justify-content-between align-items-center">
                                          Проживание
                                          <span className="badge bg-primary rounded-pill">$150-$300</span>
                                       </li>
                                       <li className="list-group-item d-flex justify-content-between align-items-center">
                                          Питание
                                          <span className="badge bg-primary rounded-pill">$200</span>
                                       </li>
                                    </ul>
                                 </div>
                                 <div className="col-md-6">
                                    <img src="/assets/img/education/universidad-rusas-educacion.webp" alt="Сравнение стоимости жизни в России и Европе" className="img-fluid" />
                                 </div>
                              </div>
                              <p><small>Источник: <a href="https://www.numbeo.com" target="_blank" rel="noopener">Numbeo 2024</a></small></p>




                              {/* ============ ÍTEM 5 ============ */}
                              <h2>5. Рабочая Виза для Выпускников</h2>
                              <p>
                                 Выпускники могут подать заявление на трудовую резиденцию через программу "Высококвалифицированный специалист".
                              </p>

                              <p>Программа <strong>"Высококвалифицированный специалист"</strong> позволяет:</p>
                              <ul>
                                 <li>Работать без иммиграционных квот</li>
                                 <li>Гарантированная минимальная зарплата: $1,700/месяц</li>
                                 <li>Постоянное место жительства через 3 года</li>
                              </ul>

                              <ul>
                                 <li>• Студенческая виза позволяет работать 20 часов в неделю</li>
                                 <li>• Скидки на поездки в общественном транспорте</li>
                              </ul>



                              <div className="quote-wrapper">
                                 <div className="quotes">
                                    <h3>Ключевые Данные</h3>
                                    <p>
                                       • Россия инвестирует 4,3% своего ВВП в высшее образование (против 2,9% в среднем по ОЭСР), согласно <a href="https://data.oecd.org" target="_blank" rel="noopener noreferrer">OECD.Stat</a>.
                                    </p>
                                    <p>
                                       • Россия занимает 8-е место в мире по научным публикациям согласно Scimago 2023, опережая Канаду и Австралию.
                                    </p>
                                 </div>
                              </div>


                              {/* ============ ÍTEM 6 ============ */}
                              <h2>6. Дверь на Глобальные Рынки</h2>

                              <p>
                                 Соглашения о признании дипломов с 64 странами СНГ, ЕС и Азии.
                              </p>
                              <p>
                                 Выпускники российских университетов имеют преференциальный доступ к:
                              </p>
                              <ul>
                                 <li>• Программа "Высококвалифицированный специалист" для работы в России</li>
                                 <li>• Соглашения о признании дипломов с 64 странами</li>
                              </ul>

                              <p>Преимущества в трудоустройстве:</p>
                              <div className="row">
                                 <div className="col-md-6">
                                    <div className="card">
                                       <div className="card-body">
                                          <h5>Признание Дипломов</h5>
                                          <p>Действительны в 64 странах, включая:</p>
                                          <ul>
                                             <li>Европейский Союз</li>
                                             <li>Китай</li>
                                             <li>Индия</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="card">
                                       <div className="card-body">
                                          <h5>Глобальные Компании</h5>
                                          <p>Соглашения с:</p>
                                          <ul>
                                             <li>Газпром</li>
                                             <li>Яндекс</li>
                                             <li>Росатом</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                              </div>


                              {/* ============ ÍTEM 7 ============ */}
                              <h2>7. Международная Академическая Среда. Активное Международное Сообщество</h2>                               

                              <p>В 2024 году в России обучается <strong>более 300 000 иностранных студентов</strong> из:</p>
                              <div className="country-chips">
                                 <span className="badge bg-light text-dark">Китай (23%)</span>
                                 <span className="badge bg-light text-dark">Индия (18%)</span>
                                 <span className="badge bg-light text-dark">Ближний Восток (15%)</span>
                              </div>
                              <p>С организованными сообществами по странам во всех основных университетах.</p>
                              <p>
                                 Более 300 000 иностранных студентов из 170 стран создают глобальную сеть контактов.
                              </p>


                              {/* ============ ÍTEM 8 ============ */}
                              <h2>8. Современная Инфраструктура</h2>
                              <p>
                                 Лаборатории, как в <Link to="/skolkovo">Инновационном центре Сколково</Link> ("российской Силиконовой долине"), доступны для студентов.
                              </p>

                              <div className="row">
                                 <div className="col-md-6">
                                    <img src="assets/img/gallery/rusas-universidad-clases.png" alt="Инновационный центр Сколково" className="img-fluid rounded" />
                                 </div>
                                 <div className="col-md-6">
                                    <p>Выдающиеся объекты:</p>
                                    <ul>
                                       <li>Лаборатории нанотехнологий</li>
                                       <li>Космические симуляторы</li>
                                       <li>Библиотеки с более чем 5 млн томов</li>
                                    </ul>
                                 </div>
                              </div>



                              {/* ============ ÍTEM 9 ============ */}
                              <h2>9. Включенная Система Здравоохранения</h2>
                              <p>Все студенты получают:</p>
                              <ul>
                                 <li><strong>Медицинскую страховку и бесплатное обслуживание:</strong> Полное покрытие</li>
                                 <li><strong>Университетские клиники:</strong> Обслуживание 24/7</li>
                                 <li><strong>Вакцинация:</strong> Добровольная и включена</li>
                              </ul>


                              {/* ============ ÍTEM 10 ============ */}
                              <h2>10. Уникальный Культурный Опыт. Живая Культура и История</h2>
                              <p>
                                 От <Link to="/metro-moscu">московского метро</Link> до фестиваля "Белые ночи" в Санкт-Петербурге.
                              </p>
                              <p>
                                 Бесплатный вход в музеи и скидки в театрах, включая Эрмитаж и Большой театр (согласно <a href="https://www.culture.ru" target="_blank">официальному культурному порталу</a>).
                              </p>

                              <div className="row">
                                 <div className="col-md-4">
                                    <div className="card">
                                       <img src="assets/img/gallery/rusas-universidad-clases.png" className="card-img-top" alt="Музей Эрмитаж" />
                                       <div className="card-body">
                                          <h5>Бесплатный Доступ</h5>
                                          <p>Более 500 музеев для студентов</p>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-8">
                                    <p>Культурные преимущества:</p>
                                    <ul>
                                       <li>50% скидка в театрах, таких как Большой</li>
                                       <li>Бесплатные фестивали, такие как "Белые ночи"</li>
                                    </ul>
                                 </div>
                              </div>


 


                              <br></br>


                              {/* ===== SECCIÓN FINAL ===== */}
                              <div className="alert alert-info mt-4">
                                 <h4>Как Подать Заявку?</h4>
                                 <ol>
                                    <li>Выберите программу на <a href="https://studyinrussia.ru" target="_blank" rel="noopener">studyinrussia.ru</a></li>
                                    <li>Подготовьте документы (переведенные на русский язык)</li>
                                    <li>Подайте заявку до 15/12/2025</li>
                                 </ol>
                              </div>

                              <br></br> <br></br>




                              <div className="faq-section">
                                 <h3>FAQ: Часто Задаваемые Вопросы</h3>
                                 <p><strong>Сколько стоит проживание?</strong><br />
                                    От $300-$600/месяц, включая студенческое общежитие (согласно <a href="https://www.numbeo.com" target="_blank">Numbeo</a>).</p>

                                 <p><strong>Нужно ли знать русский язык?</strong><br />
                                    Нет для программ на английском, но все университеты предлагают <Link to="/cursos-ruso">бесплатные курсы</Link>.</p>
                              </div>

                              {/* ==================== Referencias Académicas ==================== */}
                              <div className="container mt-5 references">
                                 <h4>Использованные Источники</h4>
                                 <ul>
                                    <li>• Институт Статистики ЮНЕСКО (2023). <em>Глобальный отчет по мониторингу образования</em></li>
                                    <li>• Мировой рейтинг университетов QS 2024</li>
                                    <li>• Министерство науки и высшего образования России</li>
                                    <li>• Отчет ОЭСР «Образование в фокусе» за 2023 год</li>

                                 </ul>
                              </div>


                           </article>
                        </div>
                     </div>

                     {/* ============= Sección de navegación ============= */}
                     <div className="navigation-top">
                        <div className="d-sm-flex justify-content-between text-center">
                           <p className="like-info">
                              <span className="align-middle">
                                 <i className="fa fa-heart" />
                              </span>{" "}
                              Лили и еще 4 человека отметили это
                           </p>
                           <div className="col-sm-4 text-center my-2 my-sm-0">
                              <p className="comment-count">
                                 <span className="align-middle">
                                    <i className="fa fa-comment" />
                                 </span> 06 Комментариев
                              </p>
                           </div>
                           <ul className="social-icons">
                              <li>
                                 <a href="#">
                                    <i className="fab fa-facebook-f" />
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fab fa-twitter" />
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fab fa-dribbble" />
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fab fa-behance" />
                                 </a>
                              </li>
                           </ul>
                        </div>

                        <div className="navigation-area">
                           <div className="row">
                              <div className="col-lg-6 col-md-6 col-12 nav-left flex-row d-flex justify-content-start align-items-center">
                                 <div className="thumb">
                                    <a href="#">
                                       <img
                                          className="img-fluid"
                                          src="/assets/img/post/preview.png"
                                          alt="Предыдущий пост"
                                       />
                                    </a>
                                 </div>
                                 <div className="arrow">
                                    <a href="#">
                                       <span className="lnr text-white ti-arrow-left" />
                                    </a>
                                 </div>
                                 <div className="detials">
                                    <p>Предыдущий пост</p>
                                    <a href="#">
                                       <h4>Сальса вечеринки зимой</h4>
                                    </a>
                                 </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-12 nav-right flex-row d-flex justify-content-end align-items-center">
                                 <div className="detials">
                                    <p>Следующий пост</p>
                                    <a href="#">
                                       <h4>Лучшие школы танцев</h4>
                                    </a>
                                 </div>
                                 <div className="arrow">
                                    <a href="#">
                                       <span className="lnr text-white ti-arrow-right" />
                                    </a>
                                 </div>
                                 <div className="thumb">
                                    <a href="#">
                                       <img
                                          className="img-fluid"
                                          src="/assets/img/post/next.png"
                                          alt="Siguiente post"
                                       />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     {/* ============= Sección del autor ============= */}
                     <div className="blog-author">
                        <div className="media align-items-center">
                           <img src="/assets/img/education/universidad-rusas-educacion.webp" alt="Experto en educación internacional" />
                           <div className="media-body">
                              <a href="#"><h4>Dra. Irina Volkova</h4></a>
                              <p>Asesora académica con 10 años en reclutamiento internacional. Ex directora de admisiones en RUDN University.</p>
                           </div>
                        </div>
                     </div>

                     {/* ============= Sección de comentarios ============= */}
                     <div className="comments-area">
                        <h4>03 Comments</h4>
                        <div className="comment-list">
                           <div className="single-comment justify-content-between d-flex">
                              <div className="user justify-content-between d-flex">
                                 <div className="thumb">
                                    <img src="/assets/img/comment/comment_1.png" alt="Usuario comentario 1" />
                                 </div>
                                 <div className="desc">
                                    <p className="comment">
                                       ¡Increíble ambiente! La mejor forma de disfrutar el verano en Moscú. Recomendado 100%
                                    </p>
                                    <div className="d-flex justify-content-between">
                                       <div className="d-flex align-items-center">
                                          <h5>
                                             <a href="#">Anna Petrova</a>
                                          </h5>
                                          <p className="date">May 15, 2024 at 3:12 pm </p>
                                       </div>
                                       <div className="reply-btn">
                                          <a href="#" className="btn-reply text-uppercase">
                                             reply
                                          </a>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div className="comment-list">
                           <div className="single-comment justify-content-between d-flex">
                              <div className="user justify-content-between d-flex">
                                 <div className="thumb">
                                    <img src="/assets/img/comment/comment_2.png" alt="Usuario comentario 2" />
                                 </div>
                                 <div className="desc">
                                    <p className="comment">
                                       ¿Hay estacionamiento cerca del Parque Gorky? Quisiera asistir en auto
                                    </p>
                                    <div className="d-flex justify-content-between">
                                       <div className="d-flex align-items-center">
                                          <h5>
                                             <a href="#">Dmitry Sokolov</a>
                                          </h5>
                                          <p className="date">May 16, 2024 at 10:30 am </p>
                                       </div>
                                       <div className="reply-btn">
                                          <a href="#" className="btn-reply text-uppercase">
                                             reply
                                          </a>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        {/* Formulario de comentarios */}
                        <div className="comment-form">
                           <h4>Deja un comentario</h4>
                           <form className="form-contact comment_form" action="#" id="commentForm">
                              <div className="row">
                                 <div className="col-12">
                                    <div className="form-group">
                                       <textarea
                                          className="form-control w-100"
                                          name="comment"
                                          id="comment"
                                          cols={30}
                                          rows={9}
                                          placeholder="Escribe tu comentario"
                                          defaultValue={""}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="form-group">
                                       <input
                                          className="form-control"
                                          name="name"
                                          id="name"
                                          type="text"
                                          placeholder="Nombre"
                                       />
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="form-group">
                                       <input
                                          className="form-control"
                                          name="email"
                                          id="email"
                                          type="email"
                                          placeholder="Email"
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12">
                                    <div className="form-group">
                                       <input
                                          className="form-control"
                                          name="website"
                                          id="website"
                                          type="text"
                                          placeholder="Sitio web"
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="form-group">
                                 <button
                                    type="submit"
                                    className="button button-contactForm btn_1 boxed-btn"
                                 >
                                    Publicar comentario
                                 </button>
                              </div>
                           </form>
                        </div>
                     </div>
                  </div>

                  {/* ==================== Sidebar ==================== */}

                  {/* ==================== Sidebar Completo ==================== */}
                  <div className="col-lg-4">
                     <div className="blog_right_sidebar">
                        <aside className="single_sidebar_widget search_widget">
                           <form action="#">
                              <div className="form-group">
                                 <div className="input-group mb-3">
                                    <input
                                       type="text"
                                       className="form-control"
                                       placeholder="Buscar"
                                       onFocus={(e) => e.target.placeholder = ''}
                                       onBlur={(e) => e.target.placeholder = 'Buscar'}
                                    />
                                    <div className="input-group-append">
                                       <button className="btns" type="button">
                                          <i className="ti-search" />
                                       </button>
                                    </div>
                                 </div>
                              </div>
                              <button
                                 className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                                 type="submit"
                              >
                                 Buscar
                              </button>
                           </form>
                        </aside>

                        <aside className="single_sidebar_widget post_category_widget">
                           <h4 className="widget_title">Categorías</h4>
                           <ul className="list cat-list">
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Eventos</p>
                                    <p>(25)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Clases</p>
                                    <p>(12)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Consejos</p>
                                    <p>(8)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Vida Estudiantil</p>
                                    <p>(15)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Becas</p>
                                    <p>(25)</p>
                                 </a>
                              </li>
                           </ul>
                        </aside>

                        {/* ============================== */}

                        <aside className="single_sidebar_widget popular_post_widget">
                           <h3 className="widget_title">Artículos Recientes</h3>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_1.png" alt="Post reciente 1" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Domina el Ruso en 6 Meses</h3>
                                 </a>
                                 <p>Mayo 10, 2024</p>
                              </div>
                           </div>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_2.png" alt="Post reciente 2" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Historia del Baile en Rusia</h3>
                                 </a>
                                 <p>Abril 28, 2024</p>
                              </div>
                           </div>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_3.png" alt="post" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Astronomy Or Astrology</h3>
                                 </a>
                                 <p>03 Days ago</p>
                              </div>
                           </div>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_4.png" alt="post" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Asteroids telescope</h3>
                                 </a>
                                 <p>01 Days ago</p>
                              </div>
                           </div>
                        </aside>

                        {/* ============================== */}                        

                        <aside className="single_sidebar_widget tag_cloud_widget">
                           <h4 className="widget_title">Etiquetas</h4>
                           <ul className="list">
                              <li><a href="#">Universidades</a></li>
                              <li><a href="#">Estudiar medicina</a></li>
                              <li><a href="#">Moscú</a></li>
                              <li><a href="#">Idioma Ruso</a></li>
                              <li><a href="#">Costo de vida</a></li>
                              <li><a href="#">Carreras</a></li>
                           </ul>
                        </aside>

                        {/* ============================== */}
                        
                        <aside className="single_sidebar_widget instagram_feeds">
                           <h4 className="widget_title">Instagram</h4>
                           <ul className="instagram_row flex-wrap">
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_5.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_6.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_7.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_8.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_9.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_10.png" alt=""/></a></li>
                           </ul>
                        </aside>

                        <aside className="single_sidebar_widget newsletter_widget">
                           <h4 className="widget_title">Newsletter</h4>
                           <form action="#">
                              <div className="form-group">
                                 <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Ingresa tu email"
                                    required
                                 />
                              </div>
                              <button
                                 className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                                 type="submit"
                              >
                                 Suscribirse
                              </button>
                           </form>
                        </aside>
                     </div>
                  </div>

                  
               </div>
            </div>
         </section>






                  


         <Footer />
      </main >
   );
}

export default StudyInRussia;